
/**
 * Initialize GLightbox for video highlight galleries
 */
export function glightbox() {
    if (typeof GLightbox === 'undefined') {
        return;
    }

    // Find all video slider sections
    const videoSliderSections = document.querySelectorAll('.glightbox-wrapper');

    videoSliderSections.forEach((section, index) => {
        // Set unique gallery ID for this section
        const galleryId = `videoGallery-${index + 1}`;

        // Update all gallery links in this section with the unique ID
        const galleryLinks = section.querySelectorAll('.gallery-lightbox-link');
        galleryLinks.forEach(link => {
            link.setAttribute('data-glightbox', galleryId);
        });

        // Detect if the device is iOS
        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

        // Disable autoplay if iOS or screen width is below 1199px
        const disableAutoplay = isIOS || window.innerWidth < 1199;

        // Initialize GLightbox only for this section's gallery links
        const glightbox = GLightbox({
            selector: `[data-glightbox="${galleryId}"]`,
            touchNavigation: true,
            loop: true,
            autoplayVideos: !disableAutoplay, // Disable autoplay on iOS or small screens
            plyr: {
                config: {
                    muted: false,
                    vimeo: {
                        muted: false,
                    }
                }
            },
            video: {
                mute: false,
                autoplay: !disableAutoplay // Disable autoplay on iOS or small screens
            },
          
            onOpen: () => {
                document.body.classList.add('glightbox-open');
            },
            onClose: () => {
                document.body.classList.remove('glightbox-open');
            }
        });
    });

}